import { useForm } from "react-hook-form";
import Button from "../Reusable/Button";
import APIS from "../../constant/EndPoint";
import usePatchHook from "../../customHooks/usePatchHook";
import usePostHook from "../../customHooks/usePostHook";
import NumberField from "../Reusable/NumberField";
import TextField from "../Reusable/TextInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
//@ts-ignore
import { Eye, FileDown, X } from "lucide-react";
import { memo, useState } from "react";
import { toast } from "react-toastify";

const PreviewModal = memo<{
  isOpen: boolean;
  onClose: () => void;
  url: string;
  name?: string;
  type: string;
}>(({ isOpen, onClose, url, name, type }) => {
  if (!isOpen) return null;

  const handleClose = () => {
    URL.revokeObjectURL(url);
    onClose();
  };

  return (
    <div
      className={tw`fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50`}
      onClick={handleClose}
    >
      <div
        className={tw`bg-white rounded-lg shadow-xl max-w-4xl w-full h-4/5 mx-4 overflow-hidden flex flex-col`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={tw`flex items-center justify-between p-4 border-b`}>
          <h3
            className={tw`text-lg font-semibold text-gray-900 truncate max-w-[80%]`}
          >
            {name}
          </h3>
          <button
            onClick={handleClose}
            className={tw`text-gray-500 hover:text-gray-700`}
          >
            <X size={20} />
          </button>
        </div>
        <div className={tw`flex-1 overflow-auto p-4`}>
          {type.startsWith("image/") ? (
            <img
              src={url}
              alt={name}
              className={tw`max-w-full max-h-full object-contain mx-auto`}
            />
          ) : type === "application/pdf" ? (
            <iframe
              src={url}
              width="100%"
              height="100%"
              style={{ minHeight: "500px" }}
              title={name}
            />
          ) : (
            <p className={tw`text-center text-gray-600`}>
              Preview not available for this file type
            </p>
          )}
        </div>
      </div>
    </div>
  );
});

PreviewModal.displayName = "PreviewModal";

const CreateUpdateKMRecord = (props: any) => {
  const {
    selectedRider,
    setOpenEditKMRecordPopup,
    selectedDate,
    selectedDriver,
  } = props;

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    getValues,
    clearErrors,
  } = useForm<any>({
    defaultValues: async () => {
      return {
        e_km: selectedRider?.e_km,
        e_location: selectedRider?.e_location,
        s_km: selectedRider?.s_km,
        s_location: selectedRider?.s_location,
        e_remarks: selectedRider?.e_remarks,
        s_remarks: selectedRider?.s_remarks,
      };
    },
  });

  console.log("selectedRider", selectedRider);

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["km-record"],
    navigateURL: "",
  });

  const { mutateAsync: updateMutateAsync, isLoading } = usePatchHook({
    queryKey: ["km-record"],
    navigateURL: "",
  });

  const handleCreateUpdate = async (values: any, setError: any) => {
    let res;
    const url = selectedRider?.id
      ? `${APIS.KM_RECORD}${selectedRider?.id}/`
      : `${APIS.KM_RECORD}`;
    let formData = {
      ...values,
      valid_for_date: selectedRider?.valid_for_date,
      rider: selectedDriver,
    };
    try {
      if (selectedRider?.id) {
        res = await updateMutateAsync({ url, formData, setError });
      } else {
        res = await mutateAsync({ url, formData, setError });
      }
      if (res?.status === 201 || res?.status === 200) {
        setOpenEditKMRecordPopup(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleDownload = async (url: string | null) => {
    if (!url) return;
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = "km_image.jpg";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Preview failed:", error);
    }
  };

  type PreviewFile = {
    url: string;
    name?: string;
    type?: string;
  };
  const handlePreviewAttachment = async (url: string) => {
    if (!url) return;
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      setPreviewFile({
        url: objectUrl,
        type: blob.type,
      });
    } catch (err) {
      console.error("Preview error:", err);
      toast.error("Failed to load preview");
    }
  };
  const [previewFile, setPreviewFile] = useState<PreviewFile | null>(null);

  return (
    <>
      <PreviewModal
        isOpen={!!previewFile}
        onClose={() => setPreviewFile(null)}
        url={previewFile?.url || ""}
        type={previewFile?.type || ""}
      />

      <form
        onSubmit={handleSubmit((data: any) =>
          handleCreateUpdate(data, setError)
        )}
        autoComplete="off"
      >
        <div className={tw`grid grid-cols-2 gap-x-4 px-4`}>
          <div className={tw`relative`}>
            <NumberField
              setValue={setValue}
              value={getValues().s_km}
              clearErrors={clearErrors}
              label={"Start KM"}
              register={register("s_km", { required: "Start KM is required" })}
              errors={errors?.s_km}
            />
            {selectedRider?.s_km_image && (
              <div
                className={tw`absolute focus:outline-none right-3 top-11 flex items-center justify-center gap-2 `}
              >
                <button
                  type="button"
                  onClick={() =>
                    handlePreviewAttachment(selectedRider?.s_km_image)
                  }
                  className={tw` focus:outline-none hover:text-red-600 transition-colors text-red-500  `}
                >
                  <Eye size={16} />
                </button>
                <button
                  type="button"
                  className={tw`focus:outline-none hover:text-red-600 transition-colors text-red-500 `}
                  onClick={() => handleDownload(selectedRider?.s_km_image)}
                >
                  <FileDown className={tw`w-5 h-5`} />
                </button>
              </div>
            )}
          </div>

          <div className={tw`relative`}>
            <NumberField
              setValue={setValue}
              value={getValues().e_km}
              clearErrors={clearErrors}
              label={"End KM"}
              register={register("e_km", {
                required: selectedRider?.id ? "End KM is required" : false,
              })}
              errors={errors?.e_km}
            />
            {selectedRider?.e_km_image && (

                <div
                className={tw`absolute focus:outline-none right-3 top-11 flex items-center justify-center gap-2 `}
              >
                <button
                  type="button"
                  onClick={() =>
                    handlePreviewAttachment(selectedRider?.e_km_image)
                  }
                  className={tw`focus:outline-none hover:text-red-600 transition-colors text-red-500  `}
                >
                  <Eye size={16} />
                </button>
                 <button
                type="button"
                onClick={() => handleDownload(selectedRider?.e_km_image)}
                className={tw`focus:outline-none hover:text-red-600 transition-colors text-red-500`}
              >
                <FileDown className={tw`w-5 h-5 `} />
              </button>
              </div>
            )}
          </div>
          <TextField
            label={"Start Location"}
            register={register("s_location", {
              required: "Start Location is required",
            })}
            errors={errors?.s_location}
          />
          <TextField
            label={"End Location"}
            register={register("e_location", {
              required: selectedRider?.id ? "End Location is required" : false,
            })}
            errors={errors?.e_location}
          />
          <TextField
            label={"Start Remarks"}
            register={register("s_remarks")}
            errors={errors?.s_remarks}
          />
          <TextField
            label={"End Remarks"}
            register={register("e_remarks")}
            errors={errors?.e_remarks}
          />
        </div>
        <div className={tw`flex justify-end w-full`}>
          <div className={tw`w-[150px] mr-4`}>
            <Button label={"Update"} isLoading={isPostLoading || isLoading} />
          </div>
        </div>
      </form>
    </>
  );
};

export default CreateUpdateKMRecord;
